<template>
    <div class="carPayBox">
        <!--<div class="memberRuleNav">-->
            <!--<i @click="returnFn" class="iconfont iconzuojiantou"></i>-->
        <!--</div>-->
        <div class="scrollBox">
            <div class="scrollContent">
                <div class="carPayHead">
                    <div class="carMeny">
                        <span class="meny">{{CarPay}}</span>
                        <span class="menyd">元</span>
                    </div>
                    <div class="carMenyTest">
                        待付金额
                    </div>
                </div>
                <div class="carPayItem">
                    停车信息
                </div>
                <div class="carPayMessage">
                    <div class="carPayMessageItem"><span>车牌号</span><span class="carPayMessageColor">{{plate.carCode}}</span></div>
                    <div class="carPayMessageItem"><span>入场时间</span><span class="carPayMessageColor">{{plate.inTime}}</span></div>
                    <div class="carPayMessageItem"><span>支付时间</span><span class="carPayMessageColor">{{plate.payTime}}</span></div>
                    <div class="carPayMessageItem"><span>应付金额</span><span class="carPayMessageColor">{{(plate.chargeMoney/100).toFixed(2)}}元</span></div>
                </div>
                <div class="carPayItem">
                    选择优惠方式
                </div>
                <div class="carPayMessageBox">
                    <div class="carPayImgItem" @click="gotoStopCarTicket">
                        <div class="imgBox">
                            <img src="../../../assets/img/wxPay/yhj.svg" />
                        </div>
                        <div class="carPayTest">
                            <div class="carPayTitle">停车券支付</div>
                            <div class="carTest">使用停车券减停车费</div>
                        </div>
                        <div class="carSelect">
                            <img src="../../../assets/img/wxPay/rjt.svg" />
                        </div>
                    </div>
                    <div class="carPayImgItem" @click="integralStateFn">
                        <div class="imgBox">
                            <img src="../../../assets/img/wxPay/jf.svg" />
                        </div>
                        <div class="carPayTest">
                            <div class="carPayTitle">积分支付</div>
                            <div class="carTest">使用积分减停车费</div>
                        </div>
                        <div class="carSelect">
                            <img src="../../../assets/img/wxPay/rjt.svg" />
                        </div>
                    </div>
                </div>
                <div class="carPayBtn" @click="carPayFn">
                    立即支付
                </div>
            </div>
        </div>
        <div class="integralBox" v-if="integralState" @click="integralStateFn">
            <div class="integralBoxChild" @click.stop="">
                <div class="integralTitle">积分抵现</div>
                <div class="integNum">
                    <span>会员积分:</span> <span>{{carpayamt.score}}</span><span class="integralNuberd">积分</span>
                </div>
                <div class="integNum">
                    <span>可抵用:</span> <span class="integralNuber">{{carpayamt.carpayamt}}</span><span class="integralNuberd">元</span>
                </div>
                <div class="iptBox">
                    <span>输入金额</span>
                    <input type="number" v-model="integralNum"  class="ipt" />元
                    <div class="iptBtn" @click="integralMoneyFn">确认</div>
                </div>
                <div class="integralSideTitle">
                    抵现规则:
                </div>
                <div class="integralContent">
                    100积分 = 1元
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "carPay",
        data(){
            return {
                integralState: false, //积分面板
                CarPay: 0,
                loding:false,
                integralNum:0, //输入框积分
                payseqno:"",
                plate:{},
                openId:'', //客户数据
                carpayamt:'',

            }
        },
        mounted() {

            this.openId = localStorage.getItem("openId")
            document.title = "停车缴款"
            this.plate = JSON.parse(localStorage.getItem("plateData"))
            if(!this.plate.payseqno){
                this.payseqno = 0
            }else{
                this.payseqno = this.plate.payseqno
            }
            this.CarPay = (this.plate.paidMoney / 100).toFixed(2)//显示代付金额

        },
        methods:{
            // returnFn(){
            //     this.$router.go(-1)
            // },
            carPayFn(){//微信立即支付
                if(this.CarPay <= 0){
                    this.UI.Toast.failed("无需缴费")
                    return
                }
                let dt =new URLSearchParams()
                dt.append('tradeInfo','停车缴费')
                dt.append('tradeAmt',this.CarPay) //标价
                dt.append('wxOpenId',this.openId)
                dt.append('carNum', this.plate.carCode) //车牌
                dt.append('beginDate',new Date(this.plate.inTime.replace(/-/g, '/')).getTime())
                dt.append('endDate', new Date(this.plate.payTime.replace(/-/g, '/')).getTime())
                dt.append('singlePrice', this.CarPay)
                this.$http.post('/sangto-wrm/vip/park/prepay', dt).then(({data})=>{
                    let param = data.data
                    this.onBridgeReady(param);
                    if(typeof window.WeixinJSBridge == "undefined") {
                        if(document.addEventListener) {
                            document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(param), false);
                        } else if(document.attachEvent) {
                            document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(param));
                            document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(param));
                        }
                    } else {
                        this.onBridgeReady(param); //微信内部输入密码框的方法
                    }
                })
            },
            onBridgeReady(param) {
                window.WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', {
                        "appId": param.appId, //公众号名称，由商户传入
                        "timeStamp": param.timeStamp, //时间戳，自1970年以来的秒数
                        "nonceStr": param.nonceStr, //随机串
                        "package": param.package,
                        "signType": param.signType, //微信签名方式：
                        "paySign": param.paySign, //微信签名
                    },
                    (res) => {
                        if(res.err_msg == "get_brand_wcpay_request:ok"){
                            this.payseqno += 1
                            let dt = new URLSearchParams()
                            dt.append('carparkfeeno', this.plate.parkno)
                            dt.append('payseqno', this.payseqno)
                            dt.append('paycodeusemode', 'CPW')
                            dt.append('paymoney', this.CarPay)
                            this.$http.post('/sangto-wrm/vip/park/payMoney', dt).then(({data})=>{
                                // alert(JSON.stringify(data))
                                if(data.code == 200 && data.data != null){
                                    //核销成功
                                    let da = data.data
                                        if(da.code == 0){
                                            this.$router.push({name:'stopCarSucceed'})
                                        }else{
                                            this.$router.push({name:'stopCarError'})
                                        }
                                }else {
                                    this.UI.Toast.failed(data.message)
                                }
                            })
                        }else if (res.err_msg  == 'get_brand_wcpay_request:cancel') {
                            // WeixinJSBridge.call("closeWindow");
                             this.UI.Toast.failed("取消支付")
                            //  this.$router.push({name:'stopCar'})
                        }else if (res.err_msg == 'get_brand_wcpay_request:fail') {
                            this.UI.Toast.failed("网络异常，请重试")
                        }
                    })
            },
            gotoStopCarTicket(){//跳转选择优惠券
                this.plate.payseqno = this.payseqno

                this.$router.push({path:"/myCoupon", query:{"plate":JSON.stringify(this.plate)}}) //跳转到我的卡券
            },
            integralStateFn(){ //控制积分面板
                let dt = new URLSearchParams()
                dt.append('openid', this.openId)
                this.$http.post('/sangto-wrm/vip/member/getByOpenId',dt).then(({data})=>{
                    if(data.code == 200 && data.data != null){

                        let item = data.data
                        let pay = this.CarPay //标价
                        if(pay <= 0){
                            this.UI.Toast.failed("无需缴费")
                        }else{
                            this.$http.get('/sangto-wrm/vip/park/parkScoreSelect',{
                                params:{
                                    vipcardno:item.cardNo
                                }
                            }).then(({data})=>{
                                if(data.data){
                                    this.carpayamt = data.data
                                    let CarPay = Number(this.CarPay)
                                    let num = Number(data.data.carpayamt)
                                    if(CarPay < num){
                                        this.integralNum = CarPay
                                    }else{
                                        this.integralNum = num
                                    }
                                    this.integralState = !this.integralState
                                }else{
                                    this.UI.Toast.failed(data.message)
                                }

                            })
                        }
                    }else{
                        this.UI.Toast.failed(data.message)
                        this.$router.push("/register")
                    }
                })
            },
            integralMoneyFn(){//积分核销
                let num = Number(this.integralNum)
                let pay = this.CarPay //标价

                if(!Number.isInteger(num)){
                    this.UI.Toast.failed("请输入整元")
                    return
                }
                if(pay<num){
                    this.UI.Toast.failed("实付金额不能大于待付金额")
                    return
                }
                this.payseqno += 1

                let dt =new URLSearchParams()
                dt.append('carparkfeeno',this.plate.parkno)
                dt.append('payseqno', this.payseqno)
                dt.append('paycodeusemode', 'CPV')
                dt.append('paymoney',num)
                this.$http.post('/sangto-wrm/vip/park/payMoney',dt).then(({data})=>{
                    let da = data.data
                    if('code' in  da){
                        if(da.code == 0){
                            this.$router.push({name:'stopCarSucceed'})
                        }else{
                            this.$router.push({name:'stopCarError'})
                        }
                    }else{
                        this.CarPay = da.owemoney
                    }
                    this.integralState = false
                })
            }

        }
    }
</script>

<style lang="scss" scoped>
    .carPayBox{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        overflow: hidden;
        background-color: #f5f5f5;
        .scrollBox{
            position: absolute;
            /*top: 45px;*/
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
        }
        .scrollContent{
            width: 100%;
        }
        /*.memberRuleNav{*/
            /*width: 100%;*/
            /*height: 45px;*/
            /*background-color: #6cf;*/
            /*box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);*/
            /*line-height: 45px;*/
        /*}*/
        /*.iconzuojiantou{*/
            /*font-size: 24px;*/
            /*color: #fff;*/
            /*margin-left: 4px;*/
            /*padding: 6px;*/
        /*}*/
        .carPayHead{
            width: 100%;
            height: 90px;
            padding-bottom: 20px;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            /*font-size: 18px;*/
        }
        .carMenyTest{
            background-color: #fff;
            font-size: 14px;
            margin-top: 1px;
            color: #555;
        }
        .meny{
            font-size: 26px;
            font-weight: bold;
            color: #333;
        }
        .menyd{
            font-size: 12px;
            color: #555;
        }
        .carPayItem{
            width: 100%;
            text-indent: 15px;
            height: 34px;
            line-height: 34px;
            color: #555;
            font-size: 12px;
        }
        .carPayMessage{
            width: 100%;
            background-color: #fff;
            padding-left: 5%;
            padding-right: 5%;
        }
        .carPayMessageItem{
            font-size: 14px;
            height: 40px;
            line-height: 40px;
            display: flex;
            justify-content: space-between;
        }
        .carPayMessageItem:nth-of-type(1){
            border-bottom: 1px solid #f5f5f5;
        }
        .carPayMessageItem:nth-of-type(2){
            border-bottom: 1px solid #f5f5f5;
        }
        .carPayMessageItem:nth-of-type(3){
            border-bottom: 1px solid #f5f5f5;
        }
        .carPayMessageColor{
            color: #888;
        }
        .carPayImgItem{
            position: relative;
            width: 100%;
            height: 62px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #f5f5f5;
        }
        .carPayMessageBox{
            width: 100%;
            background-color: #fff;
        }
        .imgBox{
            width: 22px;
            height: 20px;
            margin-left: 18px;
        }
        .imgBox img{
            width: 100%;
            height: 100%;
        }
        .carPayTest{
            width: 55%;
            margin-left: 12px;
        }
        .carPayTitle{
            font-size: 14px;
            font-weight: 600;
            color: #333;
        }
        .carTest{
            font-size: 12px;
            color: #888;
        }
        .carSelect{
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translateY(-50%);
            width: 14px;
            height: 14px;

        }
        .carSelect img{
            width: 100%;
            height: 100%;
        }
        .carPayBtn{
            width: 90%;
            height: 44px;
            background-color: #2db7f5;
            margin: 70px auto 0 auto;
            border-radius: 5px;
            line-height: 44px;
            text-align: center;
            color: #fff;
            font-size: 14px;
            letter-spacing: 1px;
            cursor: pointer;
        }
        .integralBox{
            position: absolute;
            top: -18px;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0,0,0,0.6);
            z-index: 1000;
            display: flex;
        }
        .integralBoxChild{
            width: 80%;
            height: 300px;
            margin:20% auto 0 auto;
            background-color: #fff;
            border-radius: 8px;
        }
        .integralTitle{
            height: 45px;
            text-align: center;
            line-height: 45px;
            font-size: 14px;
            font-weight: bold;
            color: #333;
        }
        .integralSideTitle{
            font-size: 14px;
            color: #333;
            width: 100px;
            margin-left: 10%;
            margin-top: 6%;
        }
        .integralContent{
            width: 80%;
            color: #666;
            font-size: 14px;
            margin:6px auto 0 auto;
            text-indent: 30px;
            line-height: 20px;
        }
        .integNum{
            width: 80%;
            height: 26px;
            margin: auto;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
        }
        .integralNuber{
            font-size: 18px;
            font-weight: 600;
            margin-left: 4px;
            color: #555;
        }
        .integralNuberd{
            font-size: 14px;
        }
        .iptBox{
            width: 80%;
            margin: 12px auto 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-around;
            font-size: 14px;
        }
        .iptBox span{
            margin-right: 4px;
        }
        .ipt{
            height: 32px;
            width: 40%;
            border-radius: 4px !important;
            font-size: 14px;
            text-align: center;
            outline: none;
            border: none;
            -webkit-appearance: none;
            border: 1px solid #ddd;
        }
        .iptBtn{
            width: 64px;
            height: 32px;
            background-color: #2db7f5;
            color: #fff;
            font-size: 14px;
            text-align: center;
            line-height: 32px;
            border-radius: 4px;
        }
        .lodingBox{
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0,0,0,0.5);
            z-index: 1000;
            display: flex;
        }
        .lodinCont{
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
        .loding{
            width: 60px;
            height: 60px;
        }
        .lodingText{
            margin-top: 10px;
            font-size: 14px;
            color: #25a3fe;
        }
    }

</style>
